<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonEditMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'edit'">
            <div class="card">
                <div class="card-body">
                    <em-entity-edit-form ref="emEntityEditForm" :entity="modelName"></em-entity-edit-form>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
// Author LiangGangQiang
// Date 2021-12-08 14:56:39

import emCommonEditMixin from "@/mixin/em/common/edit";

export default {
    name: "sithMesPrdPpHeaderInfoModifyOwnerEditView",
    mixins: [emCommonEditMixin],
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        }
    }
};
</script>